import { mapGetters, mapActions } from 'vuex'

import headers from './headers'
import { HelpCircle, ProductTable } from '@/components/items'
import { storageUtil, currencyUtil, commonUtil } from '@/util'
import HoverPopNormal from '@/components/layouts/HoverPop/HoverPopNormal'

import DialogAlertError from '@/components/layouts/Dialogs/DialogAlert/DialogAlertError'

export default {
  components: {
    HelpCircle,
    ProductTable,
    HoverPopNormal,
    DialogAlertError
  },
  props: {
    isEditPage: { default: false },

    selectClientInfo: {
      type: Object,
      require: true,
      default: () => ({})
    },
    isClientSelect: {
      type: Boolean,
      require: true,
      default: false
    },
    isRegist: {
      type: Boolean,
      default: false
    },
    selectCurrency: {
      type: Object,
      require: true,
      default: () => {}
    },
    orderInfo: {
      type: Object,
      require: true,
      default: () => {}
    },

    historyProductMoves: {
      type: Array,
      require: false,
      default: () => []
    },

    productLackStock: {
      type: Array,
      require: false,
      default: () => []
    }
  },
  data: () => ({
    openPanelIndex: [],

    productList: [],
    productListData: [],
    fxRate: [],

    executeByLackStock: 'lackStock',
    executeByOrderInfo: 'orderInfo',

    errDialog: false
  }),
  async created() {
    await this.init()
  },
  methods: {
    ...mapActions('Product', ['getProductAndStockListFromApi']),
    ...mapGetters('Product', ['getProductAndStockListFromState']),
    ...mapActions('Common', ['setIsLoading']),

    notClientSelect() {
      alert('仕入先を選択してください')
      // this.errDialog = true
    },

    async init(executeBy = '') {
      this.setIsLoading(true)
      if (!this.isClientSelect) {
        this.productListData = []
        this.$emit('change', false, this.productListData)
        this.setIsLoading(false)
        return
      }
      if (!this.isEditPage && this.orderInfo && this.orderInfo.orderDate)
        this.fxRate = await commonUtil.getFxRate(this.orderInfo.orderDate)

      await this.createProductListData(executeBy)

      this.changeHistoryProductMoves(false)
      this.setIsLoading(false)
    },

    async createProductListData(executeBy = '') {
      const supplierId = this.selectClientInfo.selectInfo.supplierId
      await this.getProductAndStockListFromApi({ supplierId: supplierId })
      const productList = this.getProductAndStockListFromState().filter(
        (product) => {
          return this.isRegist ? product.isEnabled : true
        }
      )

      this.productList = productList
      const storageIdNameList = await storageUtil.getStorageIdNameList()
      this.productListData = productList.map((ele, index) => {
        const storage = this.getStorageProductStockAndMoving(
          storageIdNameList.data,
          ele
        )
        const order = this.getProductQuantity(ele.productPlanQuantityInfo, 2)
        const sales = this.getProductQuantity(ele.productPlanQuantityInfo, 1)

        const stock = {
          storage: storage,
          order: order ? '※注文済未出庫：' + order : '',
          sales: sales ? '※発注済未入庫：' + sales : ''
        }

        let history
        if (Object.keys(this.historyProductMoves).length) {
          history = this.historyProductMoves.find(
            (historyProduct) =>
              historyProduct.product.productId === ele.productId
          )
        }

        let orderCount = history ? history.quantity : null

        // 発注登録の不足在庫から入力した場合、
        // 個数を不足在庫分自動入力する
        if (
          executeBy === this.executeByLackStock &&
          this.getproductLackStockData(ele.productId)
        ) {
          orderCount = Math.abs(
            this.getproductLackStockData(ele.productId).lack
          )
          // 発注登録の不足在庫から入力した場合でも、
          // 仕入先情報の変更により自動で個数が0になってしまうので不足在庫入力の場合は個数のリセットを回避する
        } else if (
          executeBy === this.executeByOrderInfo &&
          this.getproductLackStockData(ele.productId)
        ) {
          orderCount = this.getProductListData(ele.productId)
            ? this.getProductListData(ele.productId).count
            : null
        }

        let amount = null
        if (this.fxRate.length > 0) {
          amount = commonUtil.exchangePriceByFxRate(
            ele.purchasePriceCurrencyId,
            this.orderInfo.currency.value,
            ele.purchasePrice,
            this.fxRate
          )
        }

        return {
          ...ele,
          productId: ele.productId,
          invalid: false,
          supplierId: ele.supplierId,
          stock: stock,
          count: orderCount,
          price: history ? history.price : this.formatPrice(amount) || 0,
          amount: history ? history.quantity * history.price : null,
          exportSubjectFlg: history
            ? history.exportSubjectFlg
            : this.isPurchasePriceCurrencyIdJa(ele.purchasePriceCurrencyId)
        }
      })
    },

    getHistoryProduct(productId) {
      this.historyProductMoves.find(
        (ele) => ele.product.productId === productId
      )
    },
    getCurrencyName(productInfo) {
      const currencyId = productInfo.purchasePriceCurrencyId
      if (currencyId) {
        return currencyUtil.findCurrencyNameById(currencyId).unitName
      }
      return ''
    },

    isOpenPanelOpen(id) {
      const group = this.groupNames.find((p) => p.groupId === id)
      return group ? group.open : false
    },

    isPurchasePriceCurrencyIdJa(id) {
      // TODO 本当は共通method
      if (id === 0) {
        return true
      }
      return false
    },

    getProductQuantity(productQuantity, transactionType) {
      const ret = productQuantity.reduce((result, current) => {
        if (
          !transactionType ||
          Number(current.transactionType) === transactionType
        ) {
          return result + current.quantity
        }
        return result
      }, 0)
      return ret
    },
    getStorageProductStockAndMoving(storageIdNameList, rec) {
      return storageIdNameList.map((ele) => {
        const stock = rec.productStockQuantityInfo.filter(
          (product) => ele.value === product.storageId
        )

        const moving = rec.productMovingQuantityInfo.filter(
          (product) => ele.value === product.storageId
        )

        return {
          storageName: ele.label,
          stock: this.getProductQuantity(stock, null),
          moving: this.getProductQuantity(moving, null)
        }
      })
    },

    getProductListData(productId) {
      return this.productListData.find((p) => p.productId === productId)
    },

    getproductLackStockData(productId) {
      return this.productLackStock.find((p) => p.productId === productId)
    },

    setGroupNamesOpen(newVal) {
      this.groupNames = this.groupNames.map((data, index) => {
        data.open = newVal.find((val) => val === data.index) !== undefined
        return data
      })
    },

    changeInvalid(...args) {
      const [invalid] = args

      this.productListData = this.productListData.map((product) => {
        product.invalid = false
        if (invalid.find((ele) => ele === product.productId)) {
          product.invalid = true
        }
        return product
      })

      // 販売商品 無効
      this.$emit('change', false, this.productListData)
    },

    setCountInput(productId, oldVal, event) {
      const isExist = event ? true : false
      event = parseInt(event)
      if (Number.isNaN(event)) {
        if (isExist) alert(this.$t('common.input_number-alert'))
        event = null
      }
      // 5桁の数字
      else if (!String(event).match(/^[0-9]{0,5}$/)) {
        event = oldVal
      }
      this.getProductListData(productId).count = event
      this.$refs[`${productId}_count`].lazyValue = event
      const product = this.getProductListData(productId)
      product.amount = product.count * product.price
      this.$emit('change', false, this.productListData)
    },

    setPriceInput(productId, oldVal, event) {
      if (!event) {
        event = null
      } else {
        if (String(event) !== '0') event = event.replace(/^0+/, '')
        // 整数13桁、小数2桁の数字
        if (!String(event).match(/^([1-9][0-9]{0,12}|0)(\.[0-9]{0,2})?$/)) {
          if (parseInt(event) != event && event)
            // 文字が含まれている場合はアラート
            alert(this.$t('common.input_number-alert'))
          event = oldVal
        }
      }
      this.getProductListData(productId).price = event
      this.$refs[`${productId}_price`].lazyValue = event
      const product = this.getProductListData(productId)
      product.amount = product.count * product.price
      this.$emit('change', false, this.productListData)
    },

    async changeHistoryProductMoves(isInit) {
      if (Object.keys(this.historyProductMoves).length > 0) {
        if (isInit) await this.init()
        // 履歴から設定時
        this.$emit('change', true, this.productListData)
      }
    },
    formatPrice(price) {
      return commonUtil.formatPrice(price)
    }
  },
  computed: {
    headers() {
      return this.isEditPage ? headers.history : headers.register
    },
    amount: function () {
      return function (productId) {
        const obj = this.getProductListData(productId)
        if (!obj) return ''
        const res = obj.count * obj.price
        obj.amount = res

        return res || res === 0
          ? this.formatPrice(Number(res)).toLocaleString() +
              this.selectCurrency.unitName
          : ''
      }
    }
  },
  watch: {
    openPanelIndex: function (val) {
      this.setGroupNamesOpen(val)
    },
    selectClientInfo: {
      deep: true,
      handler(newVal, oldVal) {
        this.init()
      }
    },

    historyProductMoves: {
      deep: true,
      async handler(newVal, oldVal) {
        this.changeHistoryProductMoves(true)
      }
    },
    productLackStock: {
      deep: true,
      async handler(newVal, oldVal) {
        if (!newVal) return
        await this.init(this.executeByLackStock)
        this.$emit('change', false, this.productListData)
      }
    },
    orderInfo: {
      deep: true,
      async handler(val) {
        await this.init(this.executeByOrderInfo)
        this.$emit('change', false, this.productListData)
      }
    }
  }
}
